import { getCurrentUser } from 'aws-amplify/auth';
import SentryWrap from "components/Sentry";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { handleListStoryStandard } from "store/story/thunks";
import StandardTable from "features/forms/admin/StandardTable";

const Wrapper = styled.div`
  height: 100%;
  padding: 20px 0px;
  width: 100%;
`;


const StandardContainer = ({
}) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        await getCurrentUser();
        await dispatch(handleListStoryStandard())
        setLoading(false);
      } catch {
        navigate("/");
      }
    }
    fetchData();
  }, []);



  return (
    <SentryWrap>
      <Wrapper className={"adminForm"}>
        <StandardTable
          userloading={loading}
        />
      </Wrapper>
    </SentryWrap>
  );
};


export default StandardContainer;
